import _ from 'lodash';

export function findNearest (value, set) {
    return set.find(maxValue => value <= maxValue) || value;
}

export function convertStringToNumber (value) {
    if (_.isNaN(Number(value)) || typeof value === 'number') {
        return value;
    }

    let decimalPlaces = 0;
    if (value.includes('.')) {
        const indx = value.indexOf('.') + 1;
        decimalPlaces = value.length - indx;
        if (decimalPlaces < 0) {
            decimalPlaces = 0;
        }
        return parseFloat(parseFloat(value).toFixed(decimalPlaces));
    }
    return parseInt(value);
    
}
